import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import Loader from "@/components/site/Loader";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Pillars from "@/components/site/Pillars";
import Services from "@/components/site/Services";
import Signature from "@/components/site/Signature";
import Ibiza from "@/components/site/Ibiza";
import InstagramSection from "@/components/site/InstagramSection";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import Admin from "@/pages/Admin";

function Site() {
  return (
    <div className="App relative bg-sand-50 text-ink-900 min-h-screen overflow-x-hidden">
      <Loader />
      <Header />
      <main>
        <Hero />
        <About />
        <Pillars />
        <Services />
        <Signature />
        <Ibiza />
        <InstagramSection />
        <Booking requestedService={null} />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </I18nProvider>
  );
}
